import { cn } from '@ifixit/ui/lib/utils';
import { Doctype } from '../../types/indices';

interface ResultImageProps {
   imageUrl?: string;
   imageSubtext?: string;
   title?: string;
   doctype?: Doctype;
}

/**
 * Determines image height class based on doctype
 */
function getImageHeightClass(doctype?: Doctype): string {
   return doctype === 'product' ? 'h-16' : 'h-12';
}

/**
 * Result image component to display the search result image with proper aspect ratio
 */
export function ResultImage({ imageUrl, imageSubtext, title, doctype }: ResultImageProps) {
   if (!imageUrl) return null;

   const imageHeight = getImageHeightClass(doctype);

   return (
      <div className="flex flex-col items-center">
         <div
            className={cn(
               'flex justify-center items-center gap-2.5 w-16',
               imageHeight,
               'rounded-lg border border-gray-200 bg-white overflow-hidden'
            )}
         >
            <img src={imageUrl} alt={title || ''} className="w-full !h-full object-cover" />
         </div>
         {imageSubtext && (
            <span className="mt-1 text-xs text-gray-600 text-center w-16 truncate">
               {imageSubtext}
            </span>
         )}
      </div>
   );
}
